export default __webpack_public_path__ + "static/82-96a838efb5b5c3e778dfa5c4b2ff2668.png";